import NavComponent from '@/components/Nav'
import FooterComponent from '@/components/Footer'
import UsermenuComponent from '@/components/Usermenu'
import { orderList } from '../../../api/server/order'
export default {
  name: 'UserOrderPage',
  data () {
    return {
      list: [],
      activeName: null,
      page: 1,
      limit: 10,
      total: 0,
    }
  },
  components: {
    'nav-component': NavComponent,
    'footer-component': FooterComponent,
    'user-menu': UsermenuComponent
  },
  methods: {
          
    currentPageChange (currentPage) {
      this.page = currentPage
      this._getOrdreList()
    },
    _getOrdreList () {
      let page = this.page
      let limit = this.limit
      let query = {
        page: page,
        limit: limit
      }
      orderList(query).then( (res) => {
        if (res.code === 200 && res.data && res.data.list) {
            let rdata = res.data
            this.list = rdata.list
            this.total = rdata.total
        } else {
            this.warning(data.message)
        }
      })
    },
    reset () {
      this.page = 1
      this.limit = 10
      this.list = []
      this._getOrdreList()
    },
    handleRoute (route) {
      if (route.name === 'user-order') {
        this.reset()
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.handleRoute(to)
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  }
}